import React, { useCallback, useContext } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useConditionalFeature } from '@americanexpress/conditional-features';
import { RenderModule } from 'holocron';
import { setRooms } from '../../ducks/requestDuck';
import { getRooms } from '../../selectors/requestSelectors';
import RoomsTravelerTooltip from './TravelerTooltip';
import HotelsContext from '../../context/hotelsContext';
import { hasDisableTravelerTooltipRule } from '../../constants/featureRulesConstants';
import ThemeContext from '../../context/themeContext';
import { ROOMS_TRAVELERS_MODULE_NAME } from '../../constants/globalConstants';

const HotelRoomTravelers = () => {
  const theme = useContext(ThemeContext);
  const {
    config: {
      maxAdults,
      maxChildren,
      maxRooms,
      maxTravelersCap,
      maxTravelersPerRoom,
    },
  } = useContext(HotelsContext);
  const hasDisableTravelerTooltip = useConditionalFeature(hasDisableTravelerTooltipRule);
  const value = useSelector(getRooms);
  const dispatch = useDispatch();
  const onChange = useCallback((rooms) => dispatch(setRooms(rooms)), [dispatch]);
  const {
    config: { isMosaicDesign = false },
  } = useContext(HotelsContext);

  return (
    isMosaicDesign
      ? (
        <RenderModule
          moduleName={ROOMS_TRAVELERS_MODULE_NAME}
          props={{
            id: 'hotels',
            lob: 'hotels',
            theme,
            onChange,
            value,
            maxAdults,
            maxChildren,
            maxRooms,
            maxTravelersCap,
            maxTravelersPerRoom,
            isMosaicDesign,
          }}
        />
      )
      : (
        <div className="pad-0 col-md-6 col-lg-4 col-xl-3 col-xs-12 flex">
          <RenderModule
            moduleName={ROOMS_TRAVELERS_MODULE_NAME}
            props={{
              id: 'hotels',
              theme,
              onChange,
              value,
              maxAdults,
              maxChildren,
              maxRooms,
              isMosaicDesign,
            }}
          />
          {!hasDisableTravelerTooltip && <RoomsTravelerTooltip />}
        </div>
      )
  );
};

export default HotelRoomTravelers;
